import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LogoComponent } from "../app-logo/app-logo";



@Component({
  selector: 'app-admin-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, LogoComponent],
  templateUrl: './app-sidebar.html',
  styleUrls: ['./app-sidebar.css']
})
export class AppSidebar {
  constructor() { }
  @Input() showToggle = true;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  @Input() collapsed = false;

  ngOnInit(): void { }

  emit() {
    this.toggleMobileNav.emit();
    this.toggleCollapsed.emit();

  }
}
